import { apiService } from "../../services";
import {
  emailConstants,
  filterConstants,
  issuesConstants,
  modelConstants,
  processConstants,
  projConstants,
} from "../constants";

export const projActions = {
  getProjects,
  openProject,
  returnProjects,
};

function getProjects(ids) {
  return (dispatch) => {
    apiService
      .getProjects(ids)
      .then((projects) => {
        dispatch(registerProjects(projects));
      })
      .catch((error) => {
        console.log("Can't get a project. ", error.message);
      });
  };

  function registerProjects(projects) {
    return {
      type: projConstants.PROJ_GETAll,
      payload: projects,
    };
  }
}

function openProject(project) {
  return (dispatch) => {
    if (project.tagIds) {
      apiService
        .getArrayData("tag", project.tagIds)
        .then((tags) => {
          project.tags = tags;
        })
        .catch((err) => {
          console.log("Can't get the tags in project.", err.message);
        });
    }

    if (project.workPhaseIds) {
      apiService
        .getArrayData("workPhase", project.workPhaseIds)
        .then((workPhases) => {
          project.workPhases = workPhases;
        })
        .catch((err) => {
          console.log("Can't load the workphase in project.", err.message);
        });
    }

    apiService
      .getDataByEndpoint(`queryfilter?projectId=${project.id}`)
      .then((res) => {
        const issueQuery = res.data.find(
          (q) => q.type === 1 && q.name === filterConstants.FILTER_NAME
        );
        dispatch(registerIssueQuery(issueQuery));
      })
      .catch((err) => {
        console.log("Can't get the QueryFilter", err.message);
      });

    apiService
      .getDataByEndpoint(`inbox/project/${project.id}`)
      .then((res) => {
        dispatch(registerEmails(res.data));
      })
      .catch((err) => {
        console.log("Can't get the emails in project", err.message);
      });

    dispatch(registerProject(project));
  };

  function registerProject(project) {
    return {
      type: projConstants.PROJ_OPEN,
      payload: project,
    };
  }

  function registerEmails(emails) {
    return {
      type: emailConstants.GET_EMAIL,
      payload: emails,
    };
  }

  function registerIssueQuery(query) {
    let issueQuery = undefined;
    if (query) {
      issueQuery = query.uiFilterSettings.issueFilter;
      if (issueQuery) issueQuery.id = query.id;
    }

    return {
      type: filterConstants.FILTER_APPLY,
      payload: issueQuery,
    };
  }
}

function returnProjects(history) {
  return (dispatch) => {
    apiService.deleteDataByEndpoint("auth-project/leave").then((res) => {
      if (res.status === 200) {
        localStorage.removeItem("projectToken");
        dispatch(resetFilter());
        dispatch(resetIssues());
        dispatch(resetProcess());
        dispatch(resetModels());
        history.push("/Projects");
        return {
          type: projConstants.PROJ_RETURN,
        };
      }
    });
  };

  function resetIssues() {
    return {
      type: issuesConstants.ISSUES_CLEAR,
    };
  }

  function resetFilter() {
    return {
      type: filterConstants.FILTER_RESET,
    };
  }

  function resetProcess() {
    return {
      type: processConstants.PROCESS_CLEAR,
    };
  }

  function resetModels() {
    return {
      type: modelConstants.MODEL_CLEAR,
    };
  }
}
